import { call, put, takeLatest, all, cancelled } from "redux-saga/effects"
import { push } from "connected-react-router"
import axios from "axios"
import { GET_QUALITATIVE_ANSWERS_WATCHER } from "./constants"

import { getQualitativeAnswersSuccess } from "./actions"
import { LOCAL_TOKEN } from "../../../utils/storage"

function getQualitativeApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: {
      "filter[question]": params.question,
      "filter[type]": params.type,
      ...params.params,
    },
    url: `${process.env.API_URL}reports/measure/${params.measure}/answers`, // params.id_survey
  })
}

export function* getAnswersSaga(params) {
  if (!params.payload.question) return

  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const answersApi = yield call(getQualitativeApi, params.payload)
    const result = answersApi.data
    yield put(getQualitativeAnswersSuccess(result))
  } catch (e) {
    const result = e
    switch (result.response.status) {
      case 404:
        yield put(push("/error"))
        break
    }
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

// Individual exports for testing
export default function* reportsPageSaga() {
  yield takeLatest(GET_QUALITATIVE_ANSWERS_WATCHER, getAnswersSaga)
  // See example in containers/HomePage/saga.js
}
